import { render, staticRenderFns } from "./EditLinkWizard.vue?vue&type=template&id=472bbcda&scoped=true&"
import script from "./EditLinkWizard.vue?vue&type=script&lang=js&"
export * from "./EditLinkWizard.vue?vue&type=script&lang=js&"
import style0 from "./EditLinkWizard.vue?vue&type=style&index=0&id=472bbcda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472bbcda",
  null
  
)

export default component.exports